/**
 * @packageDocumentation
 * @module      EmcPacketProcessor.ts
 * @description Encapsulates the processing logic for packets available from polling.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import EmcPacketCollection from "./EmcPacketCollection";
import EmcSystemCollection from "./EmcSystemCollection";
export default class EmcPacketProcessor {
    static processPacketsJson(jsonPackets) {
        jsonPackets.forEach(jsonPacket => {
            var _a;
            EmcPacketCollection.addPacket(jsonPacket);
            let packetId = jsonPacket.packetId;
            let systemId = jsonPacket.systemId;
            (_a = EmcSystemCollection.getSystem(systemId)) === null || _a === void 0 ? void 0 : _a.addPacket(packetId);
        });
    }
}
//# sourceMappingURL=EmcPacketProcessor.js.map